module.exports = __webpack_public_path__ + "static/media/feature8.2c316c42.png";